// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__973gS","title":"style_title__LPFfb","grid":"style_grid__1vuVI","field-label":"style_field-label__1MzKH","field-value":"style_field-value__2DmFB"};